// Esquema de cores para a contrução do gráfico da rosa dos ventos, separado em níveis de velocidade do vento,
// sendo o primeiro nível de menor velocidade (cor mais clara), e o último nível de maior velocidade (cor mais escura).

export const WindRoseChartDarkColors = {
	firstLevel:  "#F49009",
	secondLevel: "#E27C08",
	thirdLevel:  "#CF6806",
	fourthLevel: "#BC5405",
	fifthLevel:  "#B34A04",
	sixthLevel:  "#A93F03",
};

export const WindRoseChartLightColors = {
	firstLevel:  "#90F4EF",
	secondLevel: "#48CAE4",
	thirdLevel:  "#00B4D8",
	fourthLevel: "#0096C7",
	fifthLevel:  "#0077B6",
	sixthLevel:  "#023E8A",
};
